import VideoJsAdapter  from "@javascripts/adapters/videojs_adapter";

import "./progress_control";
import "./fullscreen_toggle";
import "./thumbnails/thumbnail_container";
import "./cinema_mode_button";
import "./vidio_logo";
import "./seek_backward_button";
import "./seek_forward_button";
import "./volume";
import "./filler";
import "./next_button";

export default class ControlBar extends VideoJsAdapter.getComponent('ControlBar') {
  constructor(player, options = {}){
    // WARN: don't initialize the component just yet, still need to do some
    // manipulation on the children configuration.
    options.initChildren = false;

    super(player, options);

    this.controlBarChildrenBuilder = [];
    this.buildVpComponents();
    // WARN: initialize children after configuration is done, unfortunately the
    // ready has been called in the parent, so some unsynchronized events are
    // expected here.
    this.initChildren();
    this.bindReplayButtonAfterSeek();
    this.bindVpVolumePanel();
    this.bindBitrateSwitcher();
    this.bindSubtitleSwitcher();
    this.bindTimeDisplaySwitcher();
  }

  vpVolumePanel() {
    return this.VpVolumePanel;
  }

  bitrateSwitcher() {
    return this.bitrateSwitcherComponent;
  }

  subtitleSwitcher() {
    return this.vpSubtitle;
  }

  bindVpVolumePanel() {
    if (this.vpVolumePanel()) {
      this.vpVolumePanel().on("mouseenter", function(){
        this.vpVolumePanel().el().classList.add('vjs-volume-slider--show');
        this.player().el().classList.add('volume-active');
      }.bind(this));

      this.vpVolumePanel().on("mouseleave", function(){
        this.vpVolumePanel().el().classList.remove('vjs-volume-slider--show');
        this.player().el().classList.remove('volume-active');
      }.bind(this));
    }
  }

  bindBitrateSwitcher() {
    if (this.bitrateSwitcher()) {
      this.bitrateSwitcher().on("click", () => {
        this.toggleProgressControl();
      });
    }
  }

  bindSubtitleSwitcher() {
    if (this.subtitleSwitcher()) {
      this.subtitleSwitcher().on("click", () => {
        this.toggleProgressControl();
      });
    }
  }

  bindTimeDisplaySwitcher() {
    if (this.VpRemainingTimeDisplay && this.currentTimeDisplay) {
      this.currentTimeDisplay.el().classList.add('hide');

      this.VpRemainingTimeDisplay.on('click', () => {
        this.toggleTimeDisplay();
      });

      this.currentTimeDisplay.on('click', () => {
        this.toggleTimeDisplay();
      });
    }
  }

  bindReplayButtonAfterSeek(){
    this.player().on("ended", function(){
      this.player().one("seeking", function(){
        this.player().play();
      }.bind(this));
    }.bind(this));
  }

  toggleProgressControl(){
    if(this.progressControl){
      if(this.progressControl.el().classList.contains('vjs-progress-control--hidden')){
        this.progressControl.show();
      } else {
        this.progressControl.hide();
      }
    }
  }

  toggleTimeDisplay() {
    if (this.VpRemainingTimeDisplay && this.currentTimeDisplay) {
      this.VpRemainingTimeDisplay.el().classList.toggle('hide');
      this.currentTimeDisplay.el().classList.toggle('hide');
    }
  }

  buildVpComponents(){
    if (this.options_.vpComponents) {
      this.appendProgressControl();
      this.appendRemainingTimeDisplay();
      this.appendCurrentTimeDisplay();
      this.appendPlayToggle();
      this.appendSeekBackward();
      this.appendSeekForward();
      this.appendNextButton();
      this.appendVolumePanel();
      this.appendLiveDisplay();
      this.appendFiller();
      this.appendSubtitle();
      this.appendEpisodesList();
      this.appendSettingsButton();
      this.appendMobileSettingsButton();
      this.appendBitrateSwitcher();
      this.appendCinemaMode();
      this.appendFullscreenToggle();
      this.appendThumbnails();
      this.appendVidioLogo();
      this.build();
    }
  }

  appendProgressControl(){
    if(this.options_.vpComponents.progressControl){
      this.controlBarChildrenBuilder.push("progressControl");
      this.controlBarChildrenBuilder.progressControl = this.options_.vpComponents.progressControl;
    }
  }

  appendRemainingTimeDisplay() {
    if (this.options_.vpComponents.vpRemainingTimeDisplay && this.options_.vpComponents.vpRemainingTimeDisplay.show){
      this.controlBarChildrenBuilder.push("VpRemainingTimeDisplay");
    }
  }

  appendCurrentTimeDisplay() {
    if (this.options_.vpComponents.vpRemainingTimeDisplay && this.options_.vpComponents.vpRemainingTimeDisplay.show && this.options_.vpComponents.vpRemainingTimeDisplay.toggleable){
      this.controlBarChildrenBuilder.push("currentTimeDisplay");
    }
  }

  appendPlayToggle() {
      this.controlBarChildrenBuilder.push("playToggle");
  }

  appendLiveDisplay() {
    if(this.options_.vpComponents.vpLiveDisplay) {
      this.controlBarChildrenBuilder.push("liveDisplay");
    }
  }

  appendSeekBackward(){
    if(this.options_.vpComponents.vpSeekBackwardButton){
      this.controlBarChildrenBuilder.push("vpSeekBackwardButton");
      this.controlBarChildrenBuilder.vpSeekBackwardButton = this.options_.vpComponents.vpSeekBackwardButton;
    }
  }

  appendSeekForward(){
    if(this.options_.vpComponents.vpSeekForwardButton){
      this.controlBarChildrenBuilder.push("vpSeekForwardButton");
      this.controlBarChildrenBuilder.vpSeekForwardButton = this.options_.vpComponents.vpSeekForwardButton;
    }
  }

  appendNextButton(){
    if(this.options_.vpComponents.vpNextButton && this.options_.vpComponents.vpNextButton.show){
      this.controlBarChildrenBuilder.push('vpNextButton');
      this.controlBarChildrenBuilder.vpNextButton = this.options_.vpComponents.vpNextButton;
    }
  }

  appendVolumePanel(){
    if (this.options_.vpComponents.vpVolumePanel) {
      this.controlBarChildrenBuilder.push("VpVolumePanel");
    }
  }

  appendFiller() {
    this.controlBarChildrenBuilder.push("VpFiller");
  }

  appendSubtitle() {
    if(this.options_.vpComponents.vpSubtitle){
      this.controlBarChildrenBuilder.push("vpSubtitle");
      this.controlBarChildrenBuilder.vpSubtitle = this.options_.vpComponents.vpSubtitle;
    }
  }

  appendEpisodesList() {
    if(this.options_.vpComponents.vpEpisodesListButton) {
      this.controlBarChildrenBuilder.push("vpEpisodesListButton");
      this.controlBarChildrenBuilder.vpEpisodesListButton = this.options_.vpComponents.vpEpisodesListButton;
    }
  }

  appendSettingsButton() {
    if (this.options_.vpComponents.vpSettingsButton && this.options_.vpComponents.vpSettingsButton.show) {
      this.controlBarChildrenBuilder.push("vpSettingsButton");
      this.controlBarChildrenBuilder.vpSettingsButton = this.options_.vpComponents.vpSettingsButton;
    }
  }

  appendMobileSettingsButton() {
    if (this.options_.vpComponents.vpMobileSettingsButton && this.options_.vpComponents.vpMobileSettingsButton.show) {
      this.controlBarChildrenBuilder.push("vpMobileSettingsButton");
      this.controlBarChildrenBuilder.vpMobileSettingsButton = this.options_.vpComponents.vpMobileSettingsButton;
    }
  }

  appendBitrateSwitcher(){
    if (this.options_.vpComponents.bitrateSwitcherComponent && this.options_.vpComponents.bitrateSwitcherComponent.show) {
      this.controlBarChildrenBuilder.push("bitrateSwitcherComponent");
    }
  }

  appendCinemaMode(){
    if (this.options_.vpComponents.vpCinemaModeButton && this.options_.vpComponents.vpCinemaModeButton.show) {
      this.controlBarChildrenBuilder.push("vpCinemaModeButton");
      this.controlBarChildrenBuilder.vpCinemaModeButton = this.options_.vpComponents.vpCinemaModeButton;
    }
  }

  appendFullscreenToggle(){
    if (this.options_.vpComponents.fullscreenToggle) {
      this.controlBarChildrenBuilder.push("fullscreenToggle");
      this.controlBarChildrenBuilder.fullscreenToggle = this.options_.vpComponents.fullscreenToggle;
    }
  }

  appendThumbnails(){
    if (this.options_.vpComponents.vpThumbnails) {
      this.controlBarChildrenBuilder.push("vpThumbnails");
      this.controlBarChildrenBuilder.vpThumbnails = this.options_.vpComponents.vpThumbnails;
    }
  }

  appendVidioLogo(){
    if(this.options_.vpComponents.vpVidioLogo && this.options_.vpComponents.vpVidioLogo.show){
      this.controlBarChildrenBuilder.push("vpVidioLogo");
      this.controlBarChildrenBuilder.vpVidioLogo = this.options_.vpComponents.vpVidioLogo;
    }
  }

  build() {
    this.options_.children = this.controlBarChildrenBuilder;
  }
}

VideoJsAdapter.registerComponent('ControlBar', ControlBar);
